export const Constants = {
  genericErrorMessage: 'Service error, please try again later',
  fetchPdfErrorMessage: 'An error occurred while fetching the PDF.',
  fetchPdfErrorMessageRetry:
    'An error occurred while fetching the PDF. Please try again later.',
  emailPdfErrorMessage: 'An error occurred while Emailing the PDF',
  emailPdfErrorMessageRetry:
    'An error occurred while Emailing the PDF. Please try again later.',
  sendEmailSuccess: 'Email sent successfully',
  callCenterNumber: '0860 100 333',
  invalidEmailError: 'Invalid email',
};
